import { render, staticRenderFns } from "./RecordTimestamps.vue?vue&type=template&id=6c023541&"
import script from "./RecordTimestamps.vue?vue&type=script&lang=js&"
export * from "./RecordTimestamps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports